import { Utilities } from 'src/app/services/utilities';
import { BaseVariableControl } from './_base-control';
import { AbstractControl, Validators } from '@angular/forms';




export class SingleSelectControl extends BaseVariableControl {

    get keyField() {
        const templateData = this.variable.displayMetadata.templateData;
        const firstItem = (templateData.list || templateData.List)[0];
        return Utilities.getVariableCaseInsensitive(firstItem, templateData.keyField || templateData.KeyField);
    }

    buildInitialFormControlValue() {
        const metadata = this.variable.displayMetadata;
        if (metadata.templateData) {
            const list = (metadata.templateData.list || metadata.templateData.List) as any[];
            const selectedValue = list.find(item => item[this.keyField] === this.variable.value || item[this.keyField] == metadata.templateData.selected);
                return selectedValue || this.variable.value;
            }
        return this.variable.value;
    }

    createReactiveControl(setValueChangedEvent: boolean = true) {

        this.addFormControl();

        this.setValidators(this.form.controls[this.variable.name]);

        if (setValueChangedEvent) {
            this.setOnChangeEvent(this.form.controls[this.variable.name]);
            this.variable.value = this.getVariableValue();
        }
    }

    getValue(item: any): any {
        if (item) {
            const wrapperValue = item[Utilities.getVariableCaseInsensitive(item, this.variable.name)];
            const variableName = Utilities.getVariableCaseInsensitive(item, this.variable.name);
            const propertyName = Utilities.getVariableCaseInsensitive(item[variableName], this.variable.displayMetadata.templateData.keyField);

            let result = wrapperValue;
            if (wrapperValue && propertyName) {
                result = wrapperValue[propertyName];
            }

            return result;
        } else {
            const result = this.formControl.value;
            return result != null ? result[this.keyField] : result;
        }
    }

    getDisplayValue(item: any): any {
        const tempData = this.variable.displayMetadata.templateData;
        if (tempData && tempData.keyField) {
            if (item) {
                const wrapperValue = item[Utilities.getVariableCaseInsensitive(item, this.variable.name)];
                const variableName = Utilities.getVariableCaseInsensitive(item, this.variable.name);
                const propertyName = Utilities.getVariableCaseInsensitive(item[variableName], this.variable.displayMetadata.templateData.keyField);

                let result = wrapperValue;
                if (wrapperValue && propertyName) {
                    result = wrapperValue[propertyName];
                }

                return result;
            } else {
                const result = this.variable.value;
                return result != null ? result[this.keyField] : result;
            }
        } else {
            return tempData;
        }
    }

    setValidators(formControl: AbstractControl) {

        const validators = this.variable.displayMetadata.templateData.validators?.map(element => {

            let type = <string> element.typeId;
            if (type.includes("RequiredAttribute"))
            {
                return Validators.required;
            }
        });

        formControl.setValidators(Validators.compose(validators));
    }
}
